import { render, staticRenderFns } from "./video-case-more.vue?vue&type=template&id=48a8b16e&"
import script from "./video-case-more.vue?vue&type=script&lang=js&"
export * from "./video-case-more.vue?vue&type=script&lang=js&"
import style0 from "./video-case-more.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports